import './App.css';
import { FunctionComponent } from 'react';

interface Props {
  title: string;
  client: React.ReactNode;
  description: string;
  features: React.ReactNode[];
  images?: string[];}

export const Experience: FunctionComponent<Props> = ({ title, client, description, features, images }) => {
  return (
    <div className='Experience'>
      <h2>{title} /&nbsp;
        {client}
        </h2>
      <p>{description}</p>

{images && images.map((image, index) => 
  <img key={"img" + index} className="App-logo" alt={title} src={image} />
)}

      <ul>
        {features.map((feature, index) => 
          <li key={"feature" + index}>{feature}</li>
        )}
      </ul>

    </div>
  );
}

export default Experience;
